<template>
  <!-- 学期列表 -->
  <div v-if="isSemester">
    <div class="semester-list" v-if="total">
      <div class="s-list">
        <div style="overflow:hidden">
          <div class="blue"></div>
          <p class="title" v-if="orgType != 3">{{shortName? shortName: '上海'}}中心第{{isLight}}</p>
          <p class="title" v-if="orgType === 3">{{isLight}}</p>
          <div class="right" @click="showList">
            <img src="../../assets/images/xl.png" alt />
            <p class="total" v-if="obtainInfoList.type!=3">共{{total? total-1 : semesterPageResult.count-1}}期</p>
            <p class="total" v-if="obtainInfoList.type===3">共{{total? total : semesterPageResult.count}}期</p>
          </div>
        </div>
        <!-- 就业龙虎榜分页 -->
        <div v-if="isShow" style="overflow:hidden;margin:10px 0;">
          <!-- <div
            class="semesterDomain"
            v-for="(item,index) in semester"
            :key="index"
            @click="getDomain(item.pageIndex,item.pageSize)"
          >
            <p>{{item.name}}</p>
          </div> -->
          <div style="overflow:hidden;padding-left:10px;margin-right: -38px;">
            <div class="semesterID" v-for="(item,index) in queryList" :key="index" @click="Sdetail(item.id,item.name,item.type)" :class="isLight==item.name ? 'light':''">
              <span>{{item.name}}</span>
            </div>
          </div>
          <div class="more">
            <p @click="more" v-if="queryList.length!==total">查看更多>></p>
            <p v-else>全部加载完毕...</p>
          </div>
        </div>
      </div>
      <!--  individual semester number -->
    </div>
    <SemesterDetail :detailId="detailId" :orgId="Number(orgId)" :orgType="Number(orgType)" :obtainInfoList="obtainInfoList"/>

  </div>
</template>

<script>
import SemesterDetail from "./SemesterDetail";

export default {
  props:{
    cityId:{
      type: Number,
      default: ''
    }, 
    shortName: {
      type: String,
      default: '' 
    }, 
    isSemester: {
      type: Boolean,
      default: ''
    },
    semesterPageResult: {
      type: Object,
      default: ()=>{}
    },
    obtainInfoList: {
      type: Object,
      default: ()=>{}   
    }
  },
   components: {
    SemesterDetail
  },
  data() {
    return {
      semester: "",
      index: 1,
      total: 0,
      size: 8, //pageSize,
      pageIndex: 1, //pageIndex
      sort: 2, //sort的顺序
      isShow: true,
      queryList:[],
      detailId: null,
      isLight: '',
      orgId: '',
      orgType: ''
    };
  },
  watch: {
    obtainInfoList(val) {
      this.orgType = val.type
    },
    cityId: {
      handler: function(newValue) {
        this.isShow=true
        this.size=12;
        this.pageIndex=1;
        this.sort=2;
        this.queryList = []
        this.getSemesterID()
        this.init();
        this.$emit('update', newValue)
        // this.getObtain()
      }
    },

  },
  methods: {
    init() {
      this.axios
        .get("/api/Consume/Semester/SemesterGroups", {
          params: {
            OrgId: this.cityId
            // PageSize: 1000
          }
        })
        .then(res => {
          // console.log(res)
          this.semester = res.data;
        });
    },
    getSemesterID() {
      this.axios
        .get("/api/consume/Semester/PageList", {
          params: {
            OrgId: this.cityId,
            sorttype: this.sort,
            rows: this.size,
            page: this.pageIndex
          }
        })
        .then(res => {
          // console.log(res)
          this.total = res.data.count
          res.data.results.forEach(item=>{
            this.queryList.push(item)
          })
          this.isLight = this.queryList[0].name
        });
    },
    showList() {
      this.isShow=!this.isShow
    },
    more() {
      if(this.queryList.length === this.total) return
      this.pageIndex ++;
      this.getSemesterID()
    },
    getDomain(page,size) {
      this.queryList = []
      this.sort = 1
      this.size = size
      this.pageIndex = page;
      this.getSemesterID()
    },
    Sdetail(id,name,type) {
      this.isLight = name
      this.orgId = this.cityId
      name = name.replace('期','')
      this.detailId = Number(id)
      this.orgType = type
      // console.log(this.detailId,this.isLight)
      // switch(this.cityId){
      //   case 1: cityName = 'sh_'+name+'qi/'
      //   break;
      //   case 2: cityName = 'bj_'+name+'qi/'
      //   break;
      //   case 3: cityName = 'sz_'+name+'qi/'
      //   break;
      //   case 4: cityName = 'cd_'+name+'qi/'
      //   break;
      //   case 5: cityName = 'nj_'+name+'qi/'
      //   break;
      //   case 6: cityName = 'xa_'+name+'qi/'
      //   break;
      //   case 7: cityName = 'wh_'+name+'qi/'
      //   break;
      //   case 8: cityName = 'hz_'+name+'qi/'
      //   break;
      //   case 10: cityName = 'cq_'+name+'qi/'
      //   break;
      //   case 11: cityName = 'gz_'+name+'qi/'
      //   break;
      // }
      // this.$router.push({ path: `/jobDetail/${cityName}` });
    },
  },
};
</script>

<style>
.semester-list {
  padding-bottom: 32px;
}
.s-list {
  padding-top: 46px;
  overflow: hidden;
  margin-top: -9px;
}
.s-list .blue {
  width: 6px;
  height: 30px;
  background: #64b3f1;
  float: left;
  margin-top: 5px;
  margin-left: 30px;
}
.s-list .title {
  font-size: 32px;
  color: #666;
  font-weight: bold;
  float: left;
  margin-left: 22px;
}
.s-list .right {
  width: 200px;
  float: right;
  overflow: hidden;
  margin-right: 45px;
}
.s-list .total {
  float: right;
  color: #0084ff;
  font-size: 26px;
  margin-top: 10px;
  margin-right: 10px;
}
.s-list img {
  float: right;
  width: 21.5px;
  height: 9.4px;
  margin-top: 20px;
}
.s-list .semesterDomain {
  background: #fff;
  width: 220px;
  height: 54px;
  font-size: 26px;
  text-align: center;
  line-height: 54px;
  color: #282828;
  border-radius: 27px;
  float: left;
  margin-left: 18px;
  margin-top: 26px;
}
.semesterID {
  background: #fff;
  width: 144px;
  height: 44px;
  font-size: 22px;
  border-radius: 22px;
  text-align: center;
  line-height: 44px;
  color: #9c9c9c;
  border: 1px solid #9c9c9c;
  float: left;
  margin-right: 38px;
  margin-top: 14px;
}
.semesterID.light {
  background-color: #298dfb;
  color: #fff;
  border: 1px solid #298dfb;
}
.semester-list .more {
  text-align: center;
  font-size: 26px;
  color: #747474;
  margin-top: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/jiuye/SemesterList.vue